import axios from 'axios';

const api = axios.create( {baseURL : 'http://disnorteagil.no-ip.biz:8087'});
const apiD = axios.create( {baseURL : 'http://disnorteagil.no-ip.biz:4000'});
// disnorteagil.no-ip.biz  localhost
export default api;
export { apiD };
